import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchSchedules } from '../../predict/src/core/api/business-insights-schedule';
import { queryClient } from '../core/queryClient';

type FetchSchedulesResult = Awaited<ReturnType<typeof fetchSchedules>>;
type SchedulesQueryOptions = Omit<QueryObserverOptions<FetchSchedulesResult>, 'queryKey' | 'queryFn'>;

export const schedulesQueryKey = (organisationId: string, workspaceId: string) => [
  'schedules',
  organisationId,
  workspaceId
];

export const schedulesQuery = (
  workspaceId: string,
  organisationId: string,
  options?: SchedulesQueryOptions
): QueryObserver<FetchSchedulesResult> =>
  new QueryObserver<FetchSchedulesResult>(queryClient, {
    queryKey: schedulesQueryKey(organisationId, workspaceId),
    queryFn: () => fetchSchedules(workspaceId, organisationId),
    ...options
  });
